import React from "react";
import PropTypes from "prop-types";
import CardPublishDate from "../../component-library/CardMeta/CardPublishDate";

const CardShortFooter = ({ children = null, className = "", publishDate = "", ...rest }) => {
  return (
    <div className={`card__footer ${className}`}>
      <div className="card__category "></div>
      <div className="card__meta--content">
        <CardPublishDate date={publishDate} />
        {children}
      </div>
    </div>
  );
};

CardShortFooter.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string
};

export default CardShortFooter;
